<script setup lang="ts">
const { trackEvent } = useGAnalytics();
const { setBalanceVisibilty } = useUserController();
const userStore = useUserStore();
</script>
<template>
  <div
    v-if="userStore.accountAddress"
    class="relative hidden md:flex items-center gap-2">
    <NuxtLinkLocale
      :to="`/user-portal/dashboard`"
      class="relative flex items-center gap-2 peer">
      <BaseIconWallet />
      <p
        class="peer text-neutral-200 font-semibold"
        @click="trackEvent('header_balance')">
        {{ userStore.showBalance ? roundNum(userStore.balance) : "•••••••.••" }}
      </p>
      <CommonTooltip
        v-if="userStore.showBalance"
        position="bottom"
        class="z-40 w-max">
        <template #tooltip-text>
          <p class="text-xs text-black font-semibold whitespace-nowrap">
            ~ ${{ roundNum(userStore.getBalanceInUSD) }}
          </p>
        </template>
      </CommonTooltip>
    </NuxtLinkLocale>
  </div>
</template>
